import { useState, useRef } from "react";
import Webcam from "react-webcam";

function DoorScanner() {
  const [showCamera, setShowCamera] = useState(false);
  const [capturedImages, setCapturedImages] = useState([]);
  const [previewIndex, setPreviewIndex] = useState(null);
  const [useFrontCamera, setUseFrontCamera] = useState(true); // 🔁 toggle
  const webcamRef = useRef(null);

  const videoConstraints = {
    width: 640,
    height: 480,
    facingMode: useFrontCamera ? "user" : "environment",
  };

  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      setCapturedImages([...capturedImages, imageSrc]);
      setShowCamera(false);
      setPreviewIndex(null);
    }
  };

  return (
    <div>
      <input type="file" />
      <br />
      <br />
      {!showCamera && (
        <button onClick={() => setShowCamera(true)}>Upload from Camera</button>
      )}
      {showCamera && (
        <div>
          <button onClick={() => setUseFrontCamera(!useFrontCamera)}>
            Switch to {useFrontCamera ? "Back" : "Front"} Camera
          </button>

          <Webcam
            audio={false}
            ref={webcamRef}
            height={480}
            screenshotFormat="image/jpeg"
            width={640}
            videoConstraints={videoConstraints}
          />
          <br />
          <button onClick={capturePhoto}>Save Photo</button>
        </div>
      )}
      {capturedImages.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <h4>Image Saved</h4>
          {capturedImages.map((img, index) => (
            <p
              key={index}
              style={{
                color: "blue",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => setPreviewIndex(index)}
            >
              photo_{index + 1}.jpg
            </p>
          ))}
        </div>
      )}

      {previewIndex !== null && (
        <div style={{ marginTop: "10px" }}>
          <img
            src={capturedImages[previewIndex]}
            alt={`Captured ${previewIndex + 1}`}
            style={{ width: "300px", border: "2px solid #000" }}
          />
        </div>
      )}
    </div>
  );
}

export default DoorScanner;
